import React from 'react';

import {Responsive} from 'app/general/mediaqueries';
import {ToggleButton} from 'app/procedures/components/ProcedureDiagram/ToggleButton';

type Props = {
  breakpoint: 'md' | 'lg';
  showSideDiagramButton: boolean;
  isOverlayDiagramOpen: boolean;
  toggleDiagramSidebar: () => void;
  toggleDiagramOverlay: () => void;
};

export const ToggleDiagramButton = ({
  showSideDiagramButton,
  breakpoint,
  isOverlayDiagramOpen,
  toggleDiagramSidebar,
  toggleDiagramOverlay,
}: Props) => {
  return (
    <Responsive
      breakpoint={breakpoint}
      large={
        showSideDiagramButton ? (
          <ToggleButton
            position="top"
            showingDiagram={false}
            toggleDiagram={toggleDiagramSidebar}
            iconName={'fa-sitemap'}
          />
        ) : null
      }
      small={
        <ToggleButton
          position="bottom"
          showingDiagram={isOverlayDiagramOpen}
          toggleDiagram={toggleDiagramOverlay}
          iconName={'fa-sitemap'}
        />
      }
    />
  );
};
